export const LAMBDATEST_BUILD_DATA_MINIMAL_LOADING =
  "LAMBDATEST_BUILD_DATA_MINIMAL_LOADING";
export const LAMBDATEST_BUILD_DATA_MINIMAL_SUCCESS =
  "LAMBDATEST_BUILD_DATA_MINIMAL_SUCCESS";
export const LAMBDATEST_BUILD_DATA_MINIMAL_FAILED =
  "LAMBDATEST_BUILD_DATA_MINIMAL_FAILED";
export const LAMBDATEST_BUILD_DATA_MINIMAL_CLEAR =
  "LAMBDATEST_BUILD_DATA_MINIMAL_CLEAR";

export const LAMBDATEST_OS_LIST_LOADING = "LAMBDATEST_OS_LIST_LOADING";
export const LAMBDATEST_OS_LIST_SUCCESS = "LAMBDATEST_OS_LIST_SUCCESS";
export const LAMBDATEST_OS_LIST_FAILED = "LAMBDATEST_OS_LIST_FAILED";
export const LAMBDATEST_OS_LIST_CLEAR = "LAMBDATEST_OS_LIST_CLEAR";

export const LAMBDATEST_BROWSER_LIST_LOADING =
  "LAMBDATEST_BROWSER_LIST_LOADING";
export const LAMBDATEST_BROWSER_LIST_SUCCESS =
  "LAMBDATEST_BROWSER_LIST_SUCCESS";
export const LAMBDATEST_BROWSER_LIST_FAILED = "LAMBDATEST_BROWSER_LIST_FAILED";
export const LAMBDATEST_BROWSER_LIST_CLEAR = "LAMBDATEST_BROWSER_LIST_CLEAR";

export const LAMBDATEST_USER_LIST_LOADING = "LAMBDATEST_USER_LIST_LOADING";
export const LAMBDATEST_USER_LIST_SUCCESS = "LAMBDATEST_USER_LIST_SUCCESS";
export const LAMBDATEST_USER_LIST_FAILED = "LAMBDATEST_USER_LIST_FAILED";
export const LAMBDATEST_USER_LIST_CLEAR = "LAMBDATEST_USER_LIST_CLEAR";

export const LAMBDATEST_GROUP_LIST_LOADING = "LAMBDATEST_GROUP_LIST_LOADING";
export const LAMBDATEST_GROUP_LIST_SUCCESS = "LAMBDATEST_GROUP_LIST_SUCCESS";
export const LAMBDATEST_GROUP_LIST_FAILED = "LAMBDATEST_GROUP_LIST_FAILED";

export const LAMBDATEST_BUILD_DATA_MINIMAL_SILENT_LOADING =
  "LAMBDATEST_BUILD_DATA_MINIMAL_SILENT_LOADING";
export const LAMBDATEST_BUILD_EXISTENCE_MINIMAL_LOADING =
  "LAMBDATEST_BUILD_EXISTENCE_MINIMAL_LOADING";
export const LAMBDATEST_BUILD_EXISTENCE_MINIMAL_SUCCESS =
  "LAMBDATEST_BUILD_EXISTENCE_MINIMAL_SUCCESS";
export const LAMBDATEST_BUILD_EXISTENCE_MINIMAL_FAILED =
  "LAMBDATEST_BUILD_EXISTENCE_MINIMAL_FAILED";

export const LAMBDATEST_TAG_LIST_SILENT_LOADING =
  "LAMBDATEST_TAG_LIST_SILENT_LOADING";
export const LAMBDATEST_TAG_LIST_LOADING = "LAMBDATEST_TAG_LIST_LOADING";
export const LAMBDATEST_TAG_LIST_SUCCESS = "LAMBDATEST_TAG_LIST_SUCCESS";
export const LAMBDATEST_TAG_LIST_FAILED = "LAMBDATEST_TAG_LIST_FAILED";

export const LAMBDATEST_BUILD_TAG_LIST_LOADING =
  "LAMBDATEST_BUILD_TAG_LIST_LOADING";
export const LAMBDATEST_BUILD_TAG_LIST_SUCCESS =
  "LAMBDATEST_BUILD_TAG_LIST_SUCCESS";
export const LAMBDATEST_BUILD_TAG_LIST_FAILED =
  "LAMBDATEST_BUILD_TAG_LIST_FAILED";
export const LAMBDATEST_BUILD_TAG_LIST_SILENT_LOADING =
  "LAMBDATEST_BUILD_TAG_LIST_SILENT_LOADING";

export const LAMBDATEST_BUILD_PROJECT_LIST_LOADING =
  "LAMBDATEST_BUILD_PROJECT_LIST_LOADING";
export const LAMBDATEST_BUILD_PROJECT_LIST_SUCCESS =
  "LAMBDATEST_BUILD_PROJECT_LIST_SUCCESS";
export const LAMBDATEST_BUILD_PROJECT_LIST_FAILED =
  "LAMBDATEST_BUILD_PROJECT_LIST_FAILED";
export const LAMBDATEST_BUILD_PROJECT_LIST_SILENT_LOADING =
  "LAMBDATEST_BUILD_PROJECT_LIST_SILENT_LOADING";
export const LAMBDATEST_TAG_DETAILS_LOADING = "LAMBDATEST_TAG_DETAILS_LOADING";
export const LAMBDATEST_TAG_DETAILS_SUCCESS = "LAMBDATEST_TAG_DETAILS_SUCCESS";
export const LAMBDATEST_TAG_DETAILS_FAILED = "LAMBDATEST_TAG_DETAILS_FAILED";
